/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getUserTickets = async () => {
  return progressApi.get(`/ticket/getmyticket${extractedPath}`);
};

export const getTickets = async () => {
  return progressApi.get(`/ticket/getallticket${extractedPath}`);
};

export const createTicket = async (data: any) => {
  return progressApi.post(`/ticket/createticket${extractedPath}`, data);
};

export const closeTicket = (data: any) => {
  return progressApi.post(`/ticket/closeticket${extractedPath}` + `?id=${data}`);
};

export const rejectTicket = (data: any) => {
  return progressApi.post(`/ticket/rejectticket${extractedPath}` + `?id=${data}`);
};
export const deleteTicket = (data: any) => {
  return progressApi.post(`/ticket/deleteticket${extractedPath}` + `?id=${data}`);
};
